export default __webpack_public_path__ + "static/media/helicopter.896b0946.svg";